import { render, staticRenderFns } from "./AdminReferal.vue?vue&type=template&id=09890ee6"
import script from "./AdminReferal.vue?vue&type=script&lang=js"
export * from "./AdminReferal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports